/**
 * BlackPanther.js
 * The Black Panther Hero class
 */

import { Game } from "pixi_core";
import { Hero } from "./Hero";
import { GameEvents, DEFAULT_BLACK_PANTHER_DAMAGE_REDUCTION, DEFAULT_BLACK_PANTHER_DURATION } from "../Constants";

export class BlackPanther extends Hero {
    /**
     * @public
     * @param {Object} heroData
     */
    constructor(heroData) {
        super(heroData);

        /** @private @type {Number} */
        this._abilityDuration = Game.utils.assertNumber(heroData.AbilityDuration, DEFAULT_BLACK_PANTHER_DURATION);

        /** @private @type {Number[]} */
        this._activationDamageLevel = heroData.ActivationDamageLevel;

        /** @private @type {Number[]} */
        this._abilityMinDamage = heroData.AbilityMinDamage;

        /** @private @type {Number[]} */
        this._abilityMaxDamage = heroData.AbilityMaxDamage;

        /** @private @type {Number} */
        this._abilityDamageReduction = Game.utils.assertNumber(heroData.AbilityDamageReduction, DEFAULT_BLACK_PANTHER_DAMAGE_REDUCTION);

        Game.fire(
            GameEvents.eHERO_ABILITY_BLACK_PANTHER_SETUP,
            this._activationDamageLevel,
            this._abilityMinDamage,
            this._abilityMaxDamage
        );
    }

    /**
     * @public
     * @override
     */
    useAbility() {
        super.useAbility();
        Game.fire(GameEvents.eHERO_ABILITY_BLACK_PANTHER_ACTIVATE, this._abilityDamageReduction, this._abilityDuration);
    }
}
